<template>
  <div class="good-brand">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <DatePicker type="datetimerange"
                      format="yyyy-MM-dd"
                      :value="datePic"
                      @on-change="changeDate"
                      style="width: 200px"
                      placeholder="开始时间 - 结束时间"></DatePicker>
        </FormItem>
        <FormItem label-position="top">
          <Select v-model="formItem.company_id"
                  clearable
                  filterable
                  placeholder="平台名称">
            <Option v-for="item in pushtypelist"
                    :value="item.id"
                    :key="item.id">{{item.company}}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入关键词查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable(1)">查找</Button>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable(1)">导出记录</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="columns1"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: 'good-brand',
  data () {
    return {
      loading: true,
      dataloading: true,
      formItem: {},
      datePic: [],
      datetime: [],
      pushtypelist: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      columns1: [
        {
          title: 'Id',
          key: 'id',
          width: 100,
          fixed: 'left'
        },
        {
          title: '转换平台',
          key: 'company_name',
        },
        {
          title: '用户手机号',
          key: 'phone',
        },
        {
          title: '支付订单号',
          key: 'pay_order_num',
        },
        {
          title: '其他平台积分',
          key: 'points',
        },
        // {
        //   title: '时代记忆积分',
        //   key: 'plat_points',
        // },
        {
          title: '状态',
          key: 'type',
        },
        {
          title: '同步时间',
          key: 'created_at',
        },
        // {
        //   title: '操作',
        //   key: 'action',
        //   align: 'left',
        //   render: (h, params) => {
        //     return h('div', [
        //       h('Button', {
        //         props: {
        //           type: 'error',
        //           size: 'small'
        //         },
        //         on: {
        //           click: () => {
        //             this.remove(params.row.id)
        //           }
        //         }
        //       }, '删除')
        //     ]);
        //   }
        // }
      ],
      tablelist: [],
    }
  },
  // 计算
  computed: {
  },
  // 监听
  watch: {
  },
  created: function () {
    // 取数据
    this.getTableList();
    this.getCompanyList();
  },
  methods: {
    // 筛选
    getCompanyList: function (name) {
      var ps = {
        page: 1,
        size: 20
      };
      this.$api.tongbucompany.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.pushtypelist = res.result.list;
        }
      });
      return;
    },
    getTableList: function () {
      var self = this;
      this.$api.tongbupoints.list({
        page: this.pages.page,
        size: this.pages.size
      }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          self.tablelist = res.result.list;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    changeDate (val) {
      this.datetime = val;
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs['listPage'].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var bgn_date =
        this.datetime[0] != undefined ? this.datetime[0] : "";
      var end_date =
        this.datetime[1] != undefined ? this.datetime[1] : "";
      var ps = { 'key': this.formItem.key, 'company_id': this.formItem.company_id, "page": this.pages.page, "size": this.pages.size, 'starttime': bgn_date, 'endtime': end_date };
      this.$api.tongbupoints.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  },
}
  </script>
  